import { BaseService } from "./BaseService";

export class ActivityLogService extends BaseService {
  constructor() {
    super("/admin/activity-log");
  }

  async find(params = {}) {
    try {
      const response = await this.getClient().get("/admin/activity-log", {
        params,
      });
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }

  async getBlockedUsers() {
    try {
      const response = await this.getClient().get(
        "/admin/activity-log/blocked"
      );
      return response.data;
    } catch (error) {
      this.handleError(error);
    }
  }
}
